const PrintGuestAttendee = ({ stylingForm, CSSValues, specialCSSRules, fieldOrdering }) => {
    // If present, parsed template stylingForm as backup
    const mainStylingForm = stylingForm
        ? JSON.parse(stylingForm)
        : {};

    // Proper normalization for field key (camelCase/first char lower)
    const toLowerCamelCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

    // Try to get value from live form, then from template
    const getFieldValue = (cssGuestBadgesFieldName) => {
        // Try live form (e.g. stylingForm.firstName)
        const camel = toLowerCamelCase(cssGuestBadgesFieldName);
        if (stylingForm && (stylingForm[cssGuestBadgesFieldName] !== undefined)) return stylingForm[cssGuestBadgesFieldName];
        if (stylingForm && (stylingForm[camel] !== undefined)) return stylingForm[camel];
        if (mainStylingForm && (mainStylingForm[cssGuestBadgesFieldName] !== undefined)) return mainStylingForm[cssGuestBadgesFieldName];
        if (mainStylingForm && (mainStylingForm[camel] !== undefined)) return mainStylingForm[camel];
        return "";
    };

    const determineTextStyle = (cssGuestBadgesFieldName, fieldValue) => {
        const defaultStyle = { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0" };
        const specialCssSmaller = specialCSSRules?.[`${cssGuestBadgesFieldName}Smaller`];
        const specialCssSmallest = specialCSSRules?.[`${cssGuestBadgesFieldName}Smallest`];

        if (!fieldValue) return defaultStyle;
        if (specialCssSmallest?.active && fieldValue.length > specialCssSmallest.length) return CSSValues[`${cssGuestBadgesFieldName}Smallest`] || defaultStyle;
        if (specialCssSmaller?.active && fieldValue.length > specialCssSmaller.length) return CSSValues[`${cssGuestBadgesFieldName}Smaller`] || defaultStyle;
        return CSSValues[cssGuestBadgesFieldName] || defaultStyle;
    };

    const renderTextField = (cssGuestBadgesFieldName) => {
        const fieldValue = getFieldValue(cssGuestBadgesFieldName);

        if (!CSSValues[cssGuestBadgesFieldName]) return null;

        const style = determineTextStyle(cssGuestBadgesFieldName, fieldValue);
        return <p key={cssGuestBadgesFieldName} style={style}>{fieldValue}</p>;
    };

    return (
        <>
            {fieldOrdering.map((field) => {
                return renderTextField(field.cssGuestBadgesFieldName);
            })}
        </>
    );
};

export default PrintGuestAttendee;